import { cloneDeep } from 'lodash';

const state = {
  list: [],
  topic: {},
  edit_topic: {}
};

const getters = {
  list: (state) => {
    return (state.list || []).map((x) => Object.assign(x, { popularity: x.popularity || {} }));
  },
  topic: (state) => {
    return state.topic || {};
  },
  edit_topic: (state) => {
    return state.edit_topic || {};
  }
};

const mutations = {
  SET_LIST(state, topics) {
    state.list = topics;
  },

  SET_TOPIC(state, item) {
    const topic = cloneDeep(item);
    if (!topic.popularity) {
      topic.popularity = { id: null };
    }
    state.topic = topic;
    state.edit_topic = topic;
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      const existing = cloneDeep(state.list[index]);
      this._vm.$set(
        state.list,
        index,
        Object.assign(existing, topic, {
          publishedCount: existing.publishedCount,
          notPublishedCount: existing.notPublishedCount
        })
      );
    } else {
      state.list.push(topic);
    }
  },
  EDIT_TOPIC(state, item) {
    state.edit_topic = item;
  },
  SET_NOTES(state, item) {
    if (state.topic.id === item.referenceId) {
      this._vm.$set(state.topic, 'designNotes', item.notes);
      this._vm.$set(state.edit_topic, 'designNotes', item.notes);
    }
    const index = state.list.findIndex((x) => x.id === item.referenceId);
    if (index >= 0) {
      this._vm.$set(state.list[index], 'designNotes', item.notes);
    }
  }
};

const actions = {
  load({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('topics/getAll', filter)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`topics/get?id=${id}`)
        .then((response) => {
          commit('SET_TOPIC', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  create({ commit }, topic) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('topics/create', topic)
        .then((response) => {
          commit('SET_TOPIC', response.data);
          commit('lookup/ADD_TOPIC', response.data, { root: true });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update({ commit }, topic) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('topics/update', topic)
        .then((response) => {
          commit('SET_TOPIC', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  edit({ commit }, item) {
    commit('EDIT_TOPIC', item);
  },
  savePopularity({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`topics/savePopularity?id=${req.id}&popularityId=${req.popularityId}`)
        .then((response) => {
          commit('SET_TOPIC', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
